    <template>
      <div class="container mt-5">
          <div class="block-detail">
<!--            切换前后块-->
              <div class="block-title">
                <span>Block #{{ number }}</span>
                <div class="block-click">
                  <div class="block-click-icon" @click="prevBlock()"><img src="../../images/page/arrow-left.png"/></div>
                  <div class="block-click-icon block-click-icon-two" @click="nextBlock()"><img src="../../images/page/arrow-right.png"/></div>
                </div>
              </div>
<!--            内容-->
              <div class="block-content">
                <div class="block-content-item">
                  <span>Block Height:</span>
                  <span>{{ data.number }}</span>
                </div>
                <div class="block-content-item">
                  <span>Hash:</span>
                  <span>{{data.hash}}</span>
                </div>
                <div class="block-content-item">
                  <span>Parent Hash:</span>
                  <span v-if="data.number != 0" style="cursor: pointer" class="detail-item-red" @click="getDetailHash(data.parentHash)">{{ data.parentHash }}</span>
                  <span v-else>{{ data.parentHash }}</span>
                </div>
                <div class="block-content-item">
                  <span>Timestamp:</span>
                  <span>{{updateTimestamp(data.timestamp)}} <span class="detail-item-gray">({{blockDate(data.timestamp)}})</span></span>
                </div>
                <div class="block-content-item">
                  <span>Transactions:</span>
                  <span class="detail-item-red"><router-link :to="`/transaction/${data.number}`">{{ data.txsCount }} transactions</router-link></span>
                </div>
                <div class="block-content-item">
                  <span>Validated by:</span>
                  <span> <router-link :to="`/address/${ data.miner }`">{{ data.miner }}</router-link> </span>
                </div>
                <div class="block-content-item">
                  <span>Size:</span>
                  <span> {{ data.size }} bytes</span>
                </div>
                <div class="block-content-item">
                  <span>Gas Used:</span>
                  <span>{{ data.gasUsed }}<span class="detail-item-gray">({{ parseFloat(data.gasUsed/data.gasLimit * 100).toFixed(2) }}%)</span></span>
                </div>
                <div class="block-content-item">
                  <span>Gas Limit:</span>
                  <span> {{ data.gasLimit }}</span>
                </div>
              </div>
          </div>
      </div>
    </template>

    <script>
    import moment from 'moment'
    import { updateAge, isTx, isHeight } from '@/util/index'
    export default {
      name: "detail",
      data() {
        return {
          number: '',
          total: 0,
          data: ''
        }
      },
      methods: {
        updateTimestamp(val) {
          return updateAge(val)
        },
        blockDate (val) {
          if (this.error) {
            return ''
          }
          return moment(val).format('MMM Do YYYY, HH:mm:ss Z')
          // return (new Date(this.block.timestamp)).toGMTString()
        },
        prevBlock(){
          if(this.number <1){
            return
          }
          this.number = parseFloat(this.number) - 1
          this.$router.push("/block/" + this.number)
          this.getDetail(this.number.toString())
        },
        nextBlock(){
          if(this.number >= this.total){
            return
          }
          this.number = parseFloat(this.number) + 1
          this.$router.push("/block/" + this.number)
          this.getDetail(this.number.toString())
        },
        getDetailHash(val){
          this.$router.push("/block/" + val)
          this.getDetail(val)
        },
        getDetail(nm){
          let v = this
          let url = null ;
          let param = null;
          switch (true) {
            case isHeight(nm):
              url = "blockDetailByNumber"
              param = {number: nm}
              break
            case isTx(nm):
              url = 'blockDetailByHash'
              param = {hash: nm}
              break
            default:
              return
          }
          if(!url){
            return
          }
          v.api(url, param, {
            vue: v,
            key_data: 'data',
          }).then(function (res) {
            // console.log('getDetail',res)
            if (res.code==200) {
              // console.log(res)
              v.number = res.data.blocks.number
              v.data = res.data.blocks
              v.total = res.data.total
            }
          })
        },
      },
      mounted() {
        let nm = this.$route.params.number
        this.getDetail(nm)
      }
    }
    </script>

    <style scoped lang="scss">

    .block-detail {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .block-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        font-size: 18px;
        font-weight: 600;
      }
    }

    .block-click {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-left: 20px;
    }

    .block-click-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 32px;
      width: 32px;
      border-radius: 7px;
      background: rgba(55, 114, 255, 0.1);
      cursor: pointer;
      img {
        width: 5px;
      }
    }

    .block-click-icon-two {
      margin-left: 10px;
    }

    .block-content {
      width: 100%;
      border: 1px solid rgba(55, 114, 255, 0.7);
      padding: 30px;
      border-radius: 10px;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .block-content-item {
      padding-top: 20px;
      width: 100%;
      font-weight: 500;
      font-size: 14px;
      display: flex;
      flex-direction: row;
      align-items: center;
      display: flex;
      flex-direction: row;
      align-items: center;
      span:nth-child(1) {
        width: 15%;
      }
    }

    </style>
